import React from 'react'
import { Dimmer } from 'semantic-ui-react'
import cn from 'classnames'
import { Cell } from 'styled-css-grid'

const BottomNav = ({ className, children, dim }) => (
  <Dimmer.Dimmable
    as={Cell}
    dimmed={dim}
    area='bottomNav'
    className={cn('flex vertical end nav bottom-nav', className)}
  >
    {children}
    <Dimmer active={dim} />
  </Dimmer.Dimmable>
)
export default BottomNav
